export function isImageFile(file) {
  if (!file) return false;

  if (file instanceof File) {
    return file.type.startsWith("image/");
  } else if (typeof file === "string") {
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "webp"];
    const fileExtension = file.split(".").pop().toLowerCase();
    return imageExtensions.includes(fileExtension);
  }
  return false;
}

export function isUrl(value) {
  try {
    const url = new URL(value);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch (e) {
    return false;
  }
}
